import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PHOTOS } from "../images";

const SLIDE_MS = 6500;
const FADE_S = 1.8;

export const HeroMedia = ({ y }) => {
  const slides = PHOTOS.heroSequence;
  const [i, setI] = useState(0);

  useEffect(() => {
    if (PHOTOS.heroVideo) return undefined;
    slides.forEach((s) => {
      const img = new Image();
      img.src = s.src;
    });
    const t = setInterval(() => setI((v) => (v + 1) % slides.length), SLIDE_MS);
    return () => clearInterval(t);
  }, [slides]);

  if (PHOTOS.heroVideo) {
    return (
      <motion.video
        data-testid="hero-video"
        src={PHOTOS.heroVideo}
        poster={PHOTOS.hero}
        autoPlay
        muted
        loop
        playsInline
        className="h-[115%] w-full object-cover"
        style={{ y }}
      />
    );
  }

  const zoomOut = i % 2 === 0;
  const slide = slides[i];

  return (
    <AnimatePresence initial={false}>
      <motion.div
        key={i}
        data-testid="hero-slide"
        className="absolute inset-0 overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: FADE_S, ease: "easeInOut" }}
      >
        <motion.img
          src={slide.src}
          alt={slide.alt}
          data-testid="hero-image"
          fetchpriority="high"
          className="h-[115%] w-full object-cover"
          initial={{ scale: zoomOut ? 1.18 : 1.02, x: zoomOut ? "1.5%" : "-1.5%" }}
          animate={{ scale: zoomOut ? 1.02 : 1.18, x: zoomOut ? "-1.5%" : "1.5%" }}
          transition={{ duration: (SLIDE_MS + FADE_S * 1000) / 1000, ease: "linear" }}
          style={{ y }}
        />
      </motion.div>
    </AnimatePresence>
  );
};
